import React from 'react';

import { Card, Typography } from 'antd';

import clsx from 'clsx';
import HelpTip from 'v2/components/Shared/HelpTip';

export interface ICardProps {
  title: string;
  helpText?: React.ReactNode;
  total?: React.ReactNode;
  totalColor?: string;
  percent?: React.ReactNode;
  percentColor?: string;
}

const getColorClassName = (color?: string) =>
  clsx({
    'text-(--uizz-antd-color-success)': color === 'success' || color === 'var(--uizz-antd-color-success)',
    'text-(--uizz-antd-color-error)': color === 'error' || color === 'var(--uizz-antd-color-error)',
    'text-(--uizz-antd-color-warning)': color === 'warning' || color === 'var(--uizz-antd-color-warning)',
    'text-(--uizz-antd-color-info)': color === 'info' || color === 'var(--uizz-antd-color-info)',
    'text-(--uizz-antd-color-text-secondary)':
      color === 'secondary' || color === 'var(--uizz-antd-color-text-secondary)'
  });

const ValueCard = ({ title, helpText, total, totalColor, percent, percentColor }: ICardProps) => {
  return (
    <Card size='small'>
      <div className='flex items-center gap-2'>
        <Typography.Text strong>{title}</Typography.Text>
        {helpText && <HelpTip text={helpText} />}
      </div>
      <div className='flex items-end justify-between'>
        {total != null && <Typography.Text className={getColorClassName(totalColor)}>{total}</Typography.Text>}
        {percent != null && (
          <Typography.Text strong className={getColorClassName(percentColor)}>
            {percent}%
          </Typography.Text>
        )}
      </div>
    </Card>
  );
};

export default ValueCard;
